module.exports = __webpack_public_path__ + "img/Icon material-replay.0898c3d3.svg";